import { useContext } from 'react'
import { AuthContext } from 'react-oauth2-code-pkce'

const useOAuth = () => {
  const { token, error, logIn, logOut, idToken } = useContext(AuthContext)

  return {
    oauthToken: token,
    idToken,
    error,
    oauthLogin: logIn,
    oauthLogout: logOut,
  }
}

export default useOAuth
